import { ArchiveConfirmationModal } from "./ArchiveConfirmationModal";

export default ArchiveConfirmationModal;
